import { useEffect, useState } from "react";
import { useNavigate, Outlet, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Contact, Flame, CalendarClock, Bell, MoreHorizontal } from "lucide-react";

const TABS = [
  { to: "/app", end: true, label: "Leads", icon: Contact, testid: "tab-leads" },
  { to: "/app/hot", label: "Hot", icon: Flame, testid: "tab-hot" },
  { to: "/app/followups", label: "Follow-ups", icon: CalendarClock, testid: "tab-followups" },
  { to: "/app/notifications", label: "Alerts", icon: Bell, testid: "tab-notifications", badge: true },
  { to: "/app/more", label: "More", icon: MoreHorizontal, testid: "tab-more" },
];

export default function TelecallerLayout() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const hideNav = /^\/app\/leads\//.test(pathname); // lead detail has its own sticky action bar
  const [unread, setUnread] = useState(0);

  const loadUnread = () => api.get("/notifications/unread-count").then((r) => setUnread(r.data.count)).catch(() => {});
  useEffect(() => {
    loadUnread();
    const t = setInterval(loadUnread, 30000); // efficient polling fallback for realtime alerts
    return () => clearInterval(t);
  }, []);

  return (
    <div className="app-bg min-h-screen">
      <main className="max-w-lg mx-auto px-4 pt-4 pb-28">
        <Outlet context={{ user, refreshUnread: loadUnread }} />
      </main>

      <nav className={`fixed bottom-0 inset-x-0 z-40 border-t border-slate-800 bg-slate-950/90 backdrop-blur-xl ${hideNav ? "hidden" : ""}`}>
        <div className="max-w-lg mx-auto grid grid-cols-5">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? "text-primary" : "text-slate-400"
                }`}>
              {({ isActive }) => (
                <>
                  <span className="relative">
                    <t.icon className={`h-5 w-5 ${isActive ? "" : ""}`} />
                    {t.badge && unread > 0 && (
                      <span className="absolute -top-1.5 -right-2 h-4 min-w-4 px-1 rounded-full bg-primary text-[9px] font-bold text-primary-foreground flex items-center justify-center">
                        {unread > 9 ? "9+" : unread}
                      </span>
                    )}
                  </span>
                  {t.label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
